import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SubscriptionDialogComponent } from 'src/app/common/subscription-dialog/subscription-dialog.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule,
        ButtonModule, DialogModule, DropdownModule, TranslocoModule,
    ],
    declarations: [SubscriptionDialogComponent],
    exports: [SubscriptionDialogComponent],
    providers: [CurrencyPipe]
})
export class SubscriptionsModule {
    static forRoot(): ModuleWithProviders<SubscriptionsModule> {
        return {
            ngModule: SubscriptionsModule
        };
    }
}
